import { Link } from 'react-router-dom'

import useCallApi from '../../../hooks/useCallApi'
import Campaign from '../../../templates/Campaign/Campaign'
import Loading from '../../../templates/UI/Loading/Loading'
import { useContext, useEffect, useState } from 'react'
import { set } from 'lodash'
import callAPI from '../../../helpers/callAPI'
import { SystemMessageContext } from '../../../context/SystemMessageContext'
import { useAuth } from '../../../context/AuthContext'
import Number from '../../../templates/Number/Number'
import moment from 'moment'
import Dollars from '../../../templates/Dollars/Dollars'
import { Modal } from 'react-bootstrap'
import CampaignSetupContent from '../../../components/CampaignSetupContent/CampaignSetupContent'

const CampaignList = ({ advertiserId }) => {
    const { showSystemMessage } = useContext(SystemMessageContext)
    const [dataLoaded, setDataLoaded] = useState(false)
    const [report, setReport] = useState([])
    const url = `advertiser/${advertiserId}/campaigns`
    const { data, dataLoaded: dataLoadedCampaigns } = useCallApi(url, 'GET', {}, [advertiserId])
    const [ids, setIds] = useState([])
    const [showCampaignPhaseModal, setShowCampaignPhaseModal] = useState(false)
    const [campaignPhaseData, setCampaignPhaseData] = useState(null)
    const getReport = () => {
        setDataLoaded(false)

        let url = 'campaigns/worksheetReport?ph=All';

        callAPI(url, 'GET')
            .then((result) => {
                if (result['success'] === true) {
                    setReport(result.data)
                } else if (result['success'] === false) {
                    showSystemMessage('error', result.errors.message)
                }

                setDataLoaded(true)
            })
            .catch((error) => {
                console.log(`Error while fetching top campaigns: ${error}`)
                showSystemMessage('error', 'An error occurred while fetching top campaigns')
            })
    }

    useEffect(() => {
            getReport()
    }, [])

    return (
        <div className="card mb-3">
            <Modal show={showCampaignPhaseModal && dataLoadedCampaigns && report.length > 0} onHide={() => { setShowCampaignPhaseModal(false); getReport() }} size="xl">
                <CampaignSetupContent modal refetch={getReport} campaignPhaseData={campaignPhaseData} closeModal={() => setShowCampaignPhaseModal(false)} />
            </Modal>
            <div className="card-header d-flex justify-content-between align-items-center">
                <div>Campaign List (30 day stats)</div>
                <div><Link to={`/advertiser/${advertiserId}/campaigns`}> List All </Link></div>
            </div>
            <div className="card-body p-0 table-container-scroll">
                {dataLoadedCampaigns ? (
                    data.campaign_list.length === 0 ? (
                        <div className="p-2">No data</div>
                    ) : (
                        <table className="table table-striped table-card m-0 table-hover">
                            <thead>
                                <tr>
                                    <th>Campaign</th>
                                    <th className="text-right">Clicks</th>
                                    <th className="text-right">Leads</th>
                                    <th className="text-right">Sales</th>
                                    <th width="12%" className="text-right">Net Earn.</th>
                                    <th width="12%">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.campaign_list.map((item) => (
                                    <tr key={item.id}>
                                        <td>
                                            <Campaign name={item.name} oid={item.id} status={item.status.value} />
                                        </td>
                                        <td className="text-right"><Link to={`/reports/stats/daily?startDate=${moment().add(-30, 'days').format('YYYY-MM-DD')}&endDate=${moment().format('YYYY-MM-DD')}&campaignId=${item.id}`}><Number value={item.clicks} /></Link></td>
                                        <td className="text-right"><Link to={`/reports/stats/conversions?startDate=${moment().add(-30, 'days').format('YYYY-MM-DD')}&endDate=${moment().format('YYYY-MM-DD')}&campaignId=${item.id}`}><Number value={item.leads} /></Link></td>
                                        <td className="text-right"><Link to={`/reports/stats/affiliates?startDate=${moment().add(-30, 'days').format('YYYY-MM-DD')}&endDate=${moment().format('YYYY-MM-DD')}&campaignId=${item.id}`}><Dollars value={item.sales} /></Link></td>
                                        <td className="text-right"><Link to={`/reports/stats/affiliates?startDate=${moment().add(-30, 'days').format('YYYY-MM-DD')}&endDate=${moment().format('YYYY-MM-DD')}&campaignId=${item.id}`}><Dollars value={item.net_earnings} /></Link></td>
                                        {(item.phase.name && item.phase.name !== 'Complete') ? (
                                            <td>
                                                <Link title={`Phase: ${item.phase.name}`} target="_blank" to={`/advertiser/${advertiserId}/campaignSetup?id=${item.id}`} className="text-right" onClick = {(e) => {
                                                    e.preventDefault();
                                                    console.log('data',report.find(reportItem => reportItem.offer_id === item.id))
                                                    setCampaignPhaseData(report.find(reportItem => reportItem.offer_id === item.id));
                                                    setShowCampaignPhaseModal(true);
                                                }} >
                                                    {item.status.name}
                                                </Link>
                                            </td>
                                        ) : (
                                            <td>{item.status.name}</td>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )
                ) : (
                    <Loading />
                )}
            </div>
        </div>
    )
}

export default CampaignList
